<!--
This file is part of the project: "Digiziege"
An app for animal-welfare-oriented goat husbandry and contactless weight estimation.
GitLab: https://gitlab.rlp.net/proj-wise2526-digiziege/digiziege

Copyright (c) 2026 Digiziege Team TH-Bingen

Description:
Companion app for welfare-oriented goat husbandry featuring contactless weight estimation via camera,
master data management and health tracking.
Built as a PWA with a local-first approach to ensure data privacy.

LICENSE INFORMATION:
This program is free software: you can redistribute it and/or modify it under the terms of the
GNU Affero General Public License as published by the Free Software Foundation,
either version 3 of the License, or (at your option) any later version.

This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
See the GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License along with this program.
If not, see <https://www.gnu.org/licenses/>.
-->

<template>
  <ModuleShell :title="t('views.home.activity.title')" :icon="Activity" class="h-fit cursor-pointer" @click="openActivities">
    <div class="space-y-1.5" v-if="activities.length > 0">
      <ActivityCard
        v-for="(item, i) in activities" 
        :key="i" 
        :activity="item" 
        :clickable="false" 
        :compact="true" 
      />
    </div>
    <div v-else class="text-center text-xs opacity-50 py-2">
      {{ t('common.tableList.noEntries') }}
    </div>
  </ModuleShell>
</template>

<script setup>
import { computed, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { Activity } from 'lucide-vue-next'
import ModuleShell from '@/components/ui/layout/ModuleShell.vue'
import { useActivities } from '@/utils/home/useActivities.js'
import ActivityCard from '@/components/ui/cards/ActivityCard.vue'

const { t } = useI18n()
const router = useRouter()
const { activities: allActivities, refresh } = useActivities()

const activities = computed(() => allActivities.value.slice(0, 5))

onMounted(async () => {
  await refresh()
})

function openActivities() {
  router.push('/activities')
}
</script>